import * as React from "react";
import { styled, Theme, CSSObject } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import rotas from "../../routes/grupos/rotas";
import SidebarItemCollapse from "./SidebarItemCollapse";
import SidebarItem from "./SidebarItem";
import { drawerWidth } from "../../constants";
import { Grid, IconButton } from "@mui/material";
import LogoTripLog from "../../assets/Logo_TripLog.png";
import Logo from "../../assets/Logo.png";
import MenuIcon from "@material-ui/icons/Menu";
import MenuUsuario from "../layout/MenuUsuario";

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 15px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 15px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  height: 0,
  padding: 0,
  ...theme.mixins.toolbar,
}));

const DrawerComponent = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

type Props = {
  open: boolean;
  onClose: () => void;
  onOpen: () => void;
};
const Drawer: React.FC<Props> = (props) => {
  const { open, onOpen, onClose } = props;

  const [openMenu, setOpenMenu] = React.useState<string | null>(null);
  const [menuIsOpen, setMenuIsOpen] = React.useState(false);
  const [ancora, setAncora] = React.useState<null | HTMLElement>(null);

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />

      <DrawerComponent
        ModalProps={{
          keepMounted: true, // Melhor performance de abertura em mobile.
        }}
        variant="permanent"
        open={open}
        onMouseEnter={onOpen}
        onMouseLeave={onClose}
        sx={{
          "& .MuiDrawer-paper": {
            padding: "15px",
            boxSizing: "border-box",
            borderRight: "0px",
            borderRadius: "25px",
          },
        }}
      >
        <DrawerHeader
          style={{
            justifyContent: "center",
          }}
        >
          <Grid style={{}}>
            <img
              src={open ? LogoTripLog : Logo}
              alt="Logo"
              width={open ? 180 : 50}
              height={open ? 180 : 50}
            />
          </Grid>
        </DrawerHeader>

        {rotas.map((route, index) =>
          route.sidebarProps ? (
            route.child ? (
              <SidebarItemCollapse
                drawerIsOpen={open}
                closeDrawer={onClose}
                item={route}
                openMenu={openMenu}
                setOpenMenu={setOpenMenu}
                key={index}
              />
            ) : (
              <SidebarItem item={route} key={index} closeDrawer={onClose} />
            )
          ) : null
        )}

        <div>
          <IconButton>
            <MenuIcon style={{ color: "white" }} />
          </IconButton>

          <MenuUsuario
            ancora={ancora}
            setAncora={setAncora}
            menuIsOpen={menuIsOpen}
            setMenuIsOpen={setMenuIsOpen}
          />
        </div>
      </DrawerComponent>
    </Box>
  );
};

export default Drawer;
